// Generated by GitHub Copilot
import { Type } from "class-transformer";
import type { MfaFactorType } from "#core/auth/mfa-factor-type.ts";
import MfaFactor from "./MfaFactor.ts";

/** The signed-in account's MFA factors, pending and confirmed, from `GET /auth/account/me/mfa`. */
export default class MfaFactorList {
    @Type(() => MfaFactor)
    factors: MfaFactor[] = [];

    /** The account's factor of this type, or null when it has none. */
    factorOf(type: MfaFactorType): MfaFactor | null {
        return this.factors.find((factor) => factor.type === type) ?? null;
    }
}
